/*globals $, Notify */
module.exports = function () {
    var msg,
        fn;
    $(function () {
        // Messages are hidden in a <script>-tag in document head
        $('script[data-flash]').each(function () {
            msg = $(this);
            switch (msg.data('flash')) {
            case 'debug':
            case 'info':
                fn = Notify.info;
                break;
            case 'success':
                fn = Notify.success;
                break;
            case 'warning':
                fn = Notify.warning;
                break;
            case 'error':
                fn = Notify.error;
                break;
            default:
                fn = null;
            }
            if (fn) {
                fn.call(Notify, msg.text());
            }
        });
    });
};
